export default __webpack_public_path__ + "static/media/smallColoredLogoXbank.c1727d56.svg";